
import Vue from 'vue'
import { api } from '../api'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { EventBus } from '@/event-bus'

import dayjs from 'dayjs'
import i18n from '@/i18n'
dayjs.locale(i18n.locale)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

export default Vue.extend({
	name: 'AppointmentView',
	data() {
		return {
			dayjs,
			recruiter: {
				firstName: '',
				lastName: '',
				company: '',
				avatar: ''
			},
			eventInformation: null as any,
			slotType: '',
			step: 'showInfo',
			previousStep: 'showInfo',
			rejectMessage: ''
		}
	},
	mounted(): void {
		EventBus.$emit('showSpinner')
		api.get(`/candidate/event?req_id=${this.getUrlParameter('req_id')}`)
			.then(({ data }) => {
				this.recruiter = {
					firstName: data.recruiterName,
					lastName: data.recruiterLastName,
					company: data.recruiterCompany,
					avatar: data.recruiterAvatar
				}
				this.eventInformation = data.events[0]
				this.slotType = data.invitationAttributes?.find((f: { name: string; value: string }) => f.name === 'booking_type')?.value

				const assignState = data.events[0]?.candidates?.[0]?.assignState
				if (assignState === 1) {
					this.step = 'confirmed'
				} else if (assignState === 2) {
					this.step = 'rejected'
				}
			})
			.catch((error) => {
				if (error.response?.data?.messageCode === 'BKG-006') {
					this.step = 'slotRemoved'
				} else if (error.response?.data?.messageCode === 'BKG-015') {
					this.step = 'slotExpired'
				}
			})
			.finally(() => {
				EventBus.$emit('hideSpinner')
			})
	},
	methods: {
		getUrlParameter(name: string): string {
			const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			const results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		},

		confirmEvent() {
			EventBus.$emit('showSpinner')
			api.get(`/candidate/events/confirmevent?req_id=${this.getUrlParameter('req_id')}`)
				.then(({ data }) => {
					this.eventInformation = data.event
					this.recruiter = {
						firstName: data.recruiterName,
						lastName: data.recruiterLastName,
						company: data.recruiterCompany,
						avatar: data.recruiterAvatar
					}
					this.step = 'confirmed'
				})
				.catch((error) => {
					if (error.response?.data?.messageCode === 'BKG-006') {
						this.step = 'slotRemoved'
					} else if (error.response?.data?.messageCode === 'BKG-015') {
						this.step = 'slotExpired'
					}
				})
				.finally(() => {
					EventBus.$emit('hideSpinner')
				})
		},

		rejectEvent() {
			EventBus.$emit('showSpinner')
			api.post('/candidate/events/rejectevent', {
				invitationReqId: this.getUrlParameter('req_id'),
				rejectMessage: this.rejectMessage
			})
				.then(() => {
					this.step = 'rejected'
				})
				.catch((error) => {
					if (error.response?.data?.messageCode === 'BKG-006') {
						this.step = 'slotRemoved'
					} else if (error.response?.data?.messageCode === 'BKG-015') {
						this.step = 'slotExpired'
					}
				})
				.finally(() => {
					EventBus.$emit('hideSpinner')
				})
		}
	}
})
